export default "__VITE_ASSET__a144833a__"